namespace $ {
	export const $mol_transition_enabled = $mol_memo.func(
		(next?: boolean) => next ?? !$mol_media.match('prefers-reduced-motion: reduce'),
	)
	export function $mol_transition(task: () => void) {
		if (!$mol_transition_enabled()) task()
		else if ('startViewTransition' in $mol_dom.document) return $mol_dom.document.startViewTransition(task).finished
		else task()
		return Promise.resolve()
	}
}
